import { render, staticRenderFns } from "./duoChanPinDialog.vue?vue&type=template&id=f93e99ce&scoped=true"
import script from "./duoChanPinDialog.vue?vue&type=script&lang=js"
export * from "./duoChanPinDialog.vue?vue&type=script&lang=js"
import style0 from "./duoChanPinDialog.vue?vue&type=style&index=0&id=f93e99ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f93e99ce",
  null
  
)

export default component.exports